import request from '@/utils/request'


// 查询商品评价列表
export function listEvaluate(query) {
  return request({
    url: '/goods/evaluate/list',
    method: 'get',
    params: query
  })
}

// 查询商品评价分页
export function pageEvaluate(query) {
  return request({
    url: '/goods/evaluate/page',
    method: 'get',
    params: query
  })
}

// 查询商品评价详细
export function getEvaluate(data) {
  return request({
    url: '/goods/evaluate/detail',
    method: 'get',
    params: data
  })
}

// 新增商品评价
export function addEvaluate(data) {
  return request({
    url: '/goods/evaluate/add',
    method: 'post',
    data: data
  })
}

// 修改商品评价
export function updateEvaluate(data) {
  return request({
    url: '/goods/evaluate/edit',
    method: 'post',
    data: data
  })
}

// 删除商品评价
export function delEvaluate(data) {
  return request({
    url: '/goods/evaluate/delete',
    method: 'post',
    data: data
  })
}
